// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__35Lby","colMaxWidth":"Table_colMaxWidth__3nYYp"};